import { inject, Service } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppToastService } from './app-toast.service';
import { AuthService } from './authentication/auth.service';
import { RuntimeConfigService } from './config/runtime-config.service';

@Service()
export class DepartmentAccessService {
  private readonly configService = inject(RuntimeConfigService);
  private readonly authService = inject(AuthService);
  private readonly appToastService = inject(AppToastService);

  ensureAccess(department?: string | null): void {
    if (!this.isIdentityMode()) {
      return;
    }

    if (!department) {
      return;
    }

    const profile = this.authService.getProfile();
    if (profile?.adminAccess) {
      return;
    }
    const assigned = profile?.departments ?? [];
    if (
      assigned.length === 0 ||
      !assigned.some(
        (name: string) => name.toLowerCase() === department.toLowerCase()
      )
    ) {
      this.appToastService.showPermissionDenied();
      throw new Error('Department access denied.');
    }
  }

  private isIdentityMode(): boolean {
    return (
      environment.ship &&
      this.configService.get('authenticationMode') === 'identity'
    );
  }
}
